import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import PGNewsSider from './pgNewsSider';
import PGNews from './pgNews';

class PitAndFood extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { pfNewsSiderData, pfNewsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <NoSSR>
                    <PGNewsSider content={pfNewsSiderData} />
                </NoSSR>
                <PGNews content={pfNewsData} />
            </div>
        );
    }
}

export default errorBoundary(PitAndFood);
